import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';

interface ChannelConfig {
    channel: string;
    enabled: boolean;
    label: string;
    file: File | null;
    filename: string;
    error: string;
    job: any;
    uploadProgress: number;
    uploading: boolean;
    requestError: string;
}

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #10233f;
  background: #f4f7fb;
  font-family: "Pretendard", "Spoqa Han Sans Neo", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

* {
  box-sizing: border-box;
}

.analysis-page {
  min-height: 100vh;
  background: radial-gradient(circle at 82% 2%, rgba(49, 129, 246, 0.08), transparent 28rem), #f4f7fb;
}

.hero {
  color: #fff;
  background: linear-gradient(110deg, rgba(13, 36, 68, 0.98), rgba(14, 50, 91, 0.94)), #0d2444;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.hero-inner,
.hero-menu,
.workspace {
  width: min(1320px, 100% - 64px);
  margin: 0 auto;
}

.hero-inner {
  min-height: 124px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 18px;
}

.brand-mark {
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: linear-gradient(145deg, #2aa4ff, #1a6de8);
  box-shadow: 0 12px 32px rgba(16, 110, 224, 0.38);
  font-size: 24px;
  font-weight: 800;
}

.brand-copy h1 {
  margin: 3px 0 4px;
  font-size: 25px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.brand-copy p {
  margin: 0;
  color: #b8c7da;
  font-size: 13px;
}

.eyebrow,
.section-kicker {
  color: #4daef7;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.hero-meta {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 13px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  color: #c8d6e8;
  background: rgba(255, 255, 255, 0.04);
  font-size: 12px;
}

.meta-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ed0a0;
  box-shadow: 0 0 0 4px rgba(78, 208, 160, 0.12);
}

.hero-menu {
  display: flex;
  align-items: center;
  gap: 4px;
}

.menu-button {
  position: relative;
  min-width: 116px;
  padding: 12px 16px 14px;
  border: 0;
  color: #9eb2ca;
  background: transparent;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.menu-button::after {
  content: "";
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  height: 2px;
  border-radius: 999px;
  background: transparent;
}

.menu-button.active {
  color: #fff;
}

.menu-button.active::after {
  background: #55b8ff;
}

.workspace {
  padding: 34px 0 64px;
}

.intro-row,
.section-heading,
.progress-head,
.channel-head,
.svm-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.intro-row {
  margin-bottom: 24px;
}

.intro-copy h2 {
  margin: 6px 0;
  color: #0a1d38;
  font-size: 23px;
  line-height: 1.3;
  letter-spacing: -0.03em;
}

.intro-copy p {
  margin: 0;
  color: #65758a;
  font-size: 13px;
}

.step-list {
  display: flex;
  align-items: center;
  gap: 8px;
}

.step {
  min-width: 112px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid #e0e7f0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.72);
}

.step span {
  color: #2e8fea;
  font-size: 10px;
  font-weight: 800;
}

.step strong {
  color: #43536a;
  font-size: 12px;
  font-weight: 700;
}

.environment-card {
  min-height: 70px;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 30px;
  padding: 14px 18px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 5px 20px rgba(23, 51, 83, 0.04);
}

.environment-card.ready {
  border-color: #cae9df;
  background: #f7fdfb;
}

.environment-card.blocked {
  border-color: #f1d4d8;
  background: #fff9fa;
}

.environment-icon,
.note-icon,
.condition-symbol {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #31b481;
  font-size: 15px;
  font-weight: 800;
}

.environment-icon.loading {
  color: transparent;
  border: 3px solid #dce9f5;
  border-top-color: #2c8de8;
  background: transparent;
  animation: spin 0.9s linear infinite;
}

.environment-card.blocked .environment-icon {
  background: #e45767;
}

.environment-copy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.environment-copy strong {
  font-size: 13px;
}

.environment-copy span,
.environment-copy small {
  color: #66788d;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.text-button {
  padding: 7px 10px;
  border: 0;
  color: #247bc8;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.channel-section {
  margin-bottom: 18px;
}

.section-heading {
  margin-bottom: 13px;
}

.heading-copy h3,
.progress-title h3,
.error-list h3 {
  margin: 4px 0 0;
  color: #10233f;
  font-size: 17px;
  letter-spacing: -0.02em;
}

.section-description {
  margin: 5px 0 0;
  color: #748398;
  font-size: 11px;
}

.registered-count,
.accuracy-chip {
  display: flex;
  align-items: baseline;
  gap: 3px;
  color: #7b8999;
  font-size: 11px;
}

.registered-count strong {
  color: #197cdb;
  font-size: 20px;
}

.channel-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.channel-card {
  min-width: 0;
  padding: 18px;
  border: 1px solid #dce5ef;
  border-top: 3px solid #2f91ed;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 8px 26px rgba(23, 51, 83, 0.055);
  transition: opacity 0.2s, transform 0.2s, border-color 0.2s;
}

.channel-card:hover {
  transform: translateY(-2px);
  border-color: #bfd5e9;
}

.channel-card.disabled {
  opacity: 0.58;
  border-top-color: #aeb9c5;
  box-shadow: none;
}

.channel-card.completed {
  border-color: #9fdcc7;
  border-top-color: #28ad7d;
  box-shadow: 0 10px 30px rgba(31, 154, 111, 0.1);
}

.channel-card.completed .channel-dot {
  background: #28ad7d;
  box-shadow: 0 0 0 4px #e2f7ef;
}

.channel-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.channel-name strong {
  color: #0a2748;
  font-size: 15px;
}

.channel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2f91ed;
  box-shadow: 0 0 0 4px #e8f3fd;
}

.toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}

.toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-track {
  position: relative;
  width: 30px;
  height: 17px;
  border-radius: 999px;
  background: #c7d0db;
  transition: background 0.2s;
}

.toggle-track::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(12, 32, 58, 0.25);
  transition: transform 0.2s;
}

.toggle input:checked + .toggle-track {
  background: #2f91ed;
}

.toggle input:checked + .toggle-track::after {
  transform: translateX(13px);
}

.toggle-label {
  color: #77879a;
  font-size: 10px;
  font-weight: 700;
}

.field-group {
  margin-top: 18px;
}

.field-group > label {
  display: block;
  margin-bottom: 7px;
  color: #52647a;
  font-size: 11px;
  font-weight: 700;
}

.select-wrap {
  position: relative;
}

.select-wrap select {
  width: 100%;
  height: 39px;
  padding: 0 34px 0 11px;
  border: 1px solid #d8e1eb;
  border-radius: 8px;
  outline: none;
  color: #263d59;
  background: #fbfcfe;
  font: inherit;
  font-size: 12px;
  appearance: none;
}

.select-wrap select:focus {
  border-color: #62a9eb;
  box-shadow: 0 0 0 3px rgba(47, 145, 237, 0.11);
}

.select-arrow {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #8190a0;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(-50%);
}

.file-drop {
  min-height: 92px;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 12px;
  border: 1px dashed #b9cbe0;
  border-radius: 9px;
  background: #f8fbfe;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s, background 0.2s;
}

.file-drop:hover {
  border-color: #489be9;
  background: #f2f8fd;
}

.file-drop.inactive {
  cursor: not-allowed;
  background: #f3f5f7;
}

.file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.file-symbol {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 1px solid #c9dbee;
  border-radius: 8px;
  color: #2889e5;
  background: #fff;
  font-size: 16px;
  font-weight: 700;
}

.file-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-copy strong {
  color: #344b65;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-copy span {
  color: #8a98a8;
  font-size: 9px;
  line-height: 1.4;
}

.field-error {
  margin: 7px 0 0;
  color: #cf4354 !important;
  font-size: 10px !important;
  line-height: 1.5;
}

.channel-action {
  margin-top: 16px;
}

.channel-analysis-button {
  width: 100%;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #2586df;
  border-radius: 9px;
  color: #fff;
  background: linear-gradient(135deg, #2d98ef, #1976d2);
  box-shadow: 0 7px 17px rgba(31, 124, 208, 0.18);
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.channel-analysis-button:disabled {
  border-color: #c7d1dc;
  color: #8492a2;
  background: #edf1f5;
  box-shadow: none;
  cursor: not-allowed;
}

.channel-action small {
  display: block;
  min-height: 28px;
  margin-top: 6px;
  color: #8795a5;
  font-size: 9px;
  line-height: 1.45;
}

.channel-request-error {
  margin-top: 12px;
  padding: 10px;
  border: 1px solid #f0cdd2;
  border-radius: 8px;
  color: #a73544;
  background: #fff7f8;
}

.channel-request-error strong,
.channel-request-error p {
  margin: 0;
  font-size: 10px;
}

.channel-request-error p {
  margin-top: 3px;
  line-height: 1.45;
}

.channel-result {
  margin-top: 15px;
  padding-top: 14px;
  border-top: 1px solid #edf1f5;
}

.result-line {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
}

.result-line em {
  margin-left: auto;
  color: #6d7c8d;
  font-style: normal;
  font-size: 10px;
}

.state-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a5b0bd;
}

.state-running,
.state-queued,
.state-pending {
  background: #2f91ed;
}

.state-completed {
  background: #2aae7e;
}

.state-error,
.state-failed {
  background: #df5162;
}

.mini-progress,
.overall-progress {
  overflow: hidden;
  border-radius: 999px;
  background: #e8edf3;
}

.mini-progress {
  height: 4px;
  margin: 8px 0;
}

.mini-progress span,
.overall-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2589e9, #47b4ee);
  transition: width 0.3s ease;
}

.channel-result p {
  margin: 0;
  color: #718195;
  font-size: 10px;
}

.result-metrics {
  display: flex;
  gap: 14px;
  margin-top: 8px;
  color: #78889a;
  font-size: 10px;
}

.result-metrics b {
  margin-right: 3px;
  color: #1a79d2;
  font-size: 12px;
}

.result-validation {
  margin-left: auto;
  padding: 3px 6px;
  border-radius: 999px;
  color: #167d59;
  background: #e6f7ef;
  font-weight: 800;
}

.result-validation.mismatch {
  color: #a4531b;
  background: #fff0df;
}

.path-review-button {
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 11px;
  padding: 8px 10px;
  border: 1px solid #b9d9f4;
  border-radius: 9px;
  color: #155e9e;
  text-align: left;
  background: #f2f8fe;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, transform 0.2s;
}

.path-review-button:hover {
  border-color: #5fa9e9;
  background: #eaf5fe;
  transform: translateY(-1px);
}

.path-review-icon {
  flex: 0 0 auto;
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #fff;
  background: #2789df;
  font-size: 12px;
  font-weight: 800;
}

.path-review-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.path-review-copy strong {
  font-size: 10px;
}

.path-review-copy small {
  color: #6f859a;
  font-size: 9px;
}

.action-card,
.progress-panel,
.result-section {
  margin-top: 16px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(23, 51, 83, 0.05);
}

.action-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 18px;
}

.condition-note {
  display: flex;
  align-items: center;
  gap: 12px;
}

.note-icon {
  width: 29px;
  height: 29px;
  color: #207fd7;
  background: #e9f4fe;
  font-family: Georgia, serif;
  font-size: 14px;
}

.note-copy strong {
  font-size: 11px;
}

.note-copy p {
  margin: 3px 0 0;
  color: #728195;
  font-size: 11px;
}

.svm-action-card {
  border-color: #cbdff1;
  background: linear-gradient(115deg, #ffffff, #f7fbff);
}

.ready-channel-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.ready-chip {
  padding: 4px 7px;
  border: 1px solid #b9dfd1;
  border-radius: 999px;
  color: #177d59;
  background: #edf9f5;
  font-size: 9px;
  font-weight: 800;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.primary-button,
.secondary-button {
  min-width: 128px;
  height: 42px;
  padding: 0 19px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.primary-button {
  border: 1px solid #1d7bd4;
  color: #fff;
  background: linear-gradient(135deg, #238be8, #176fc9);
  box-shadow: 0 8px 20px rgba(28, 124, 212, 0.22);
}

.primary-button:disabled {
  border-color: #b5c1ce;
  background: #b5c1ce;
  box-shadow: none;
  cursor: not-allowed;
}

.secondary-button {
  min-width: auto;
  border: 1px solid #d6e0ea;
  color: #53667d;
  background: #fff;
}

.error-banner {
  margin-top: 14px;
  padding: 13px 16px;
  border: 1px solid #f0cdd2;
  border-radius: 10px;
  color: #a73544;
  background: #fff7f8;
}

.error-banner strong {
  font-size: 12px;
}

.error-banner p {
  margin: 4px 0 0;
  font-size: 11px;
}

.progress-panel {
  padding: 20px;
}

.status-pill {
  padding: 6px 10px;
  border-radius: 999px;
  color: #286da9;
  background: #eaf4fd;
  font-size: 10px;
  font-weight: 800;
}

.status-pill.state-completed {
  color: #18805c;
  background: #e7f7f0;
}

.status-pill.state-completed_with_warnings {
  color: #a46911;
  background: #fff4dc;
}

.status-pill.state-failed {
  color: #a73544;
  background: #fdecef;
}

.overall-progress {
  height: 8px;
  margin-top: 18px;
}

.progress-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  color: #8190a1;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.progress-meta strong {
  color: #257fcf;
}

.result-section {
  padding: 20px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.summary-card {
  min-width: 0;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  background: #fbfcfe;
}

.summary-label {
  display: block;
  margin-bottom: 9px;
  color: #7c8b9d;
  font-size: 10px;
  font-weight: 750;
}

.summary-card strong {
  color: #173c65;
  font-size: 18px;
}

.summary-card p {
  margin: 6px 0 0;
  color: #748398;
  font-size: 10px;
  line-height: 1.5;
}

.svm-panel {
  margin-top: 26px;
}

.accuracy-chip {
  padding: 6px 10px;
  border-radius: 999px;
  color: #176fc9;
  background: #edf6fe;
  font-weight: 750;
}

.svm-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.svm-card {
  overflow: hidden;
  border: 1px solid #dfe7ef;
  border-radius: 12px;
  background: #fff;
}

.svm-card-head {
  padding: 13px 14px;
  border-bottom: 1px solid #e8edf2;
}

.pair-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pair-title span {
  color: #728094;
  font-size: 9px;
}

.pair-title strong {
  color: #185f9f;
  font-size: 17px;
}

.sample-count {
  color: #8492a2;
  font-size: 9px;
}

.svm-card img {
  display: block;
  width: 100%;
  aspect-ratio: 6/5;
  object-fit: contain;
  background: #f6f8fb;
}

.svm-card > p {
  margin: 0;
  padding: 10px 13px;
  color: #8794a3;
  background: #fafbfd;
  font-size: 9px;
  line-height: 1.5;
}

.condition-panel {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-top: 22px;
  padding: 16px;
  border: 1px solid #eeddae;
  border-radius: 11px;
  background: #fffbef;
}

.condition-symbol {
  width: 31px;
  height: 31px;
  background: #dfa52c;
}

.condition-copy strong {
  color: #7b5a16;
  font-size: 12px;
}

.condition-copy p {
  margin: 4px 0 0;
  color: #8e7442;
  font-size: 11px;
}

.error-list {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid #f0d2d6;
  border-radius: 11px;
  background: #fff9fa;
}

.error-list h3 {
  color: #a43d4a;
  font-size: 12px;
}

.error-list ul {
  margin: 9px 0 0;
  padding-left: 18px;
}

.error-list li {
  margin-top: 4px;
  color: #86525a;
  font-size: 11px;
  line-height: 1.5;
}

.validation-view,
.svm-result-view {
  min-height: 520px;
}

.validation-empty {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 48px 24px;
  border: 1px dashed #cbd8e6;
  border-radius: 16px;
  text-align: center;
  background: rgba(255, 255, 255, 0.72);
}

.empty-symbol {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  margin-bottom: 15px;
  border-radius: 14px;
  color: #2687df;
  background: #eaf4fd;
  font-size: 20px;
}

.validation-empty strong {
  color: #183b61;
  font-size: 15px;
}

.validation-empty p {
  max-width: 480px;
  margin: 8px 0 20px;
  color: #718197;
  font-size: 12px;
  line-height: 1.6;
}

.validation-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.validation-channel-tabs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 9px;
  padding: 10px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
}

.validation-channel-tab {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 13px;
  border: 1px solid #dfe7f0;
  border-radius: 10px;
  color: #587087;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s, box-shadow 0.2s;
}

.validation-channel-tab:hover {
  border-color: #91bfe8;
  color: #176fc9;
}

.validation-channel-tab.active {
  border-color: #4b9de4;
  color: #176fc9;
  background: #eef7ff;
  box-shadow: 0 0 0 2px rgba(47, 145, 237, 0.1);
}

.validation-tab-name {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.validation-tab-name strong {
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.validation-tab-count {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  color: #6c7e91;
  background: #f0f4f8;
  font-size: 9px;
  font-weight: 800;
}

.validation-channel-tab.active .validation-tab-count {
  color: #176fc9;
  background: #dceefe;
}

.validation-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 20px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: #fff;
}

.summary-copy h3 {
  margin: 4px 0;
  color: #102b4c;
  font-size: 17px;
}

.summary-copy p {
  margin: 0;
  color: #748499;
  font-size: 11px;
}

.validation-total {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 9px 12px;
  border-radius: 10px;
  color: #7b8999;
  background: #f1f7fd;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.validation-total strong {
  color: #197bd6;
  font-size: 22px;
}

.validation-channel-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.validation-channel {
  scroll-margin-top: 18px;
  padding: 20px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 26px rgba(23, 51, 83, 0.045);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.validation-channel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf1f5;
}

.validation-badge {
  padding: 6px 10px;
  border-radius: 999px;
  color: #177d59;
  background: #e6f7ef;
  font-size: 10px;
  font-weight: 800;
}

.validation-badge.mismatch {
  color: #a4531b;
  background: #fff0df;
}

.validation-status-group {
  display: flex;
  align-items: center;
  gap: 7px;
}

.selected-channel-badge {
  padding: 6px 10px;
  border-radius: 999px;
  color: #176fc9;
  background: #eaf4fd;
  font-size: 10px;
  font-weight: 800;
}

.count-metrics {
  display: grid;
  grid-template-columns: 1fr auto 1fr 1fr 1.2fr;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}

.count-metric {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e2e9f0;
  border-radius: 10px;
  background: #fafcfe;
}

.count-metric span {
  display: block;
  margin-bottom: 5px;
  color: #7b899a;
  font-size: 9px;
}

.count-metric strong {
  color: #173e68;
  font-size: 17px;
}

.count-arrow {
  color: #70a9d9;
  font-size: 18px;
}

.tracking-diagnostics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.diagnostic-chip {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 7px 9px;
  border: 1px solid #e2e9f0;
  border-radius: 8px;
  color: #7a899b;
  background: #f8fafc;
  font-size: 9px;
}

.diagnostic-chip strong {
  color: #286da9;
  font-size: 11px;
}

.count-warning,
.warning-list {
  margin-top: 14px;
  padding: 13px 15px;
  border: 1px solid #efdbb8;
  border-radius: 10px;
  color: #845c1f;
  background: #fffaf0;
}

.count-warning strong,
.warning-list h3 {
  margin: 0;
  font-size: 11px;
}

.count-warning p {
  margin: 4px 0 0;
  font-size: 10px;
  line-height: 1.5;
}

.path-gallery-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
}

.path-gallery-heading strong {
  color: #163d67;
  font-size: 12px;
}

.path-gallery-heading span {
  padding: 4px 7px;
  border-radius: 999px;
  color: #176fc9;
  background: #edf6fe;
  font-size: 9px;
  font-weight: 800;
}

.path-gallery {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  max-height: 620px;
  margin-top: 9px;
  padding: 2px 4px 4px 2px;
  overflow: auto;
}

.path-card {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid #e0e7ef;
  border-radius: 10px;
  background: #0b1420;
}

.path-card img {
  display: block;
  width: 100%;
  aspect-ratio: 16/10;
  object-fit: contain;
  background: #05090e;
}

.path-card figcaption {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 10px;
  color: #8a98a8;
  background: #fff;
  font-size: 8px;
}

.path-card figcaption strong {
  color: #3a5069;
  font-size: 9px;
}

.path-empty {
  margin-top: 16px;
  padding: 20px;
  border: 1px dashed #d4dee8;
  border-radius: 10px;
  text-align: center;
  background: #fafcfe;
}

.path-empty strong {
  color: #596d83;
  font-size: 11px;
}

.path-empty p {
  margin: 5px 0 0;
  color: #8593a3;
  font-size: 10px;
}

.warning-list {
  margin-top: 0;
}

.warning-list ul {
  margin: 8px 0 0;
  padding-left: 18px;
}

.warning-list li {
  margin-top: 4px;
  font-size: 10px;
  line-height: 1.5;
}

.sample-panel {
  margin-bottom: 18px;
  padding: 20px;
  border: 1px solid #d9e5f0;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(21, 56, 92, 0.045);
}

.sample-panel-head,
.sample-controls,
.selected-sample,
.version-overview,
.run-history-head,
.code-inspector-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.sample-title h3 {
  margin: 5px 0 4px;
  color: #102b4c;
  font-size: 17px;
}

.sample-title p {
  margin: 0;
  color: #718197;
  font-size: 11px;
}

.sample-persistence {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 11px;
  border-radius: 999px;
  color: #27745a;
  background: #edf9f4;
  font-size: 10px;
}

.persistence-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #36b986;
  box-shadow: 0 0 0 4px rgba(54, 185, 134, 0.12);
}

.sample-controls {
  align-items: flex-end;
  margin-top: 16px;
}

.sample-select-group,
.sample-create-group {
  min-width: 0;
  flex: 1;
}

.sample-select-group > label,
.sample-create-group > label {
  display: block;
  margin-bottom: 7px;
  color: #526b84;
  font-size: 10px;
  font-weight: 800;
}

.sample-select-group select,
.sample-create-row input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d6e0ea;
  border-radius: 9px;
  outline: none;
  color: #173e68;
  background: #fbfdff;
  font: inherit;
  font-size: 11px;
}

.sample-select-group select:focus,
.sample-create-row input:focus {
  border-color: #55a7eb;
  box-shadow: 0 0 0 3px rgba(42, 145, 234, 0.1);
}

.sample-create-row {
  display: flex;
  gap: 8px;
}

.sample-create-row .secondary-button {
  flex: 0 0 auto;
  min-width: 110px;
}

.selected-sample {
  align-items: flex-end;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #edf1f5;
}

.selected-sample-copy {
  flex: 0 0 auto;
}

.selected-sample-copy span,
.selected-sample-copy em {
  display: block;
  color: #7c8b9c;
  font-size: 9px;
  font-style: normal;
}

.selected-sample-copy strong {
  display: block;
  margin: 3px 0;
  color: #123a65;
  font-size: 14px;
}

.sample-version-alert {
  min-width: 220px;
  padding: 9px 11px;
  border: 1px solid #f0d6af;
  border-radius: 9px;
  color: #86501c;
  background: #fff9ef;
}

.sample-version-alert strong,
.sample-version-alert span {
  display: block;
  font-size: 9px;
}

.sample-version-alert span {
  margin-top: 3px;
  color: #9a714b;
}

.danger-button {
  flex: 0 0 auto;
  height: 38px;
  padding: 0 14px;
  border: 1px solid #efc8ce;
  border-radius: 9px;
  color: #af3f50;
  background: #fff8f9;
  font: inherit;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

.danger-button:hover:not(:disabled) {
  border-color: #e7aab4;
  background: #fff0f2;
}

.danger-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.sample-empty {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 14px;
  padding: 13px 15px;
  border: 1px dashed #bcd4e9;
  border-radius: 10px;
  color: #326f9f;
  background: #f5faff;
  font-size: 10px;
}

.code-selection-panel {
  margin: 18px 0 24px;
  padding: 20px;
  border: 1px solid #cfe0ef;
  border-radius: 15px;
  background: linear-gradient(145deg, #ffffff, #f7fbff);
  box-shadow: 0 8px 28px rgba(21, 56, 92, 0.045);
}

.code-selection-head,
.code-selector-title,
.result-sample-picker,
.result-sample-copy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.code-selection-hint {
  flex: 0 0 auto;
  padding: 7px 10px;
  border-radius: 999px;
  color: #286b9d;
  background: #eaf5fe;
  font-size: 9px;
  font-weight: 800;
}

.code-selector-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 16px;
}

.code-selector-card {
  min-width: 0;
  padding: 15px;
  border: 1px solid #dbe6ef;
  border-radius: 12px;
  background: #fff;
}

.code-selector-title {
  align-items: flex-end;
  margin-bottom: 10px;
}

.code-selector-title strong {
  color: #153d66;
  font-size: 12px;
}

.code-selector-title span {
  color: #8291a2;
  font-size: 9px;
}

.selected-code-detail {
  min-height: 88px;
  margin-top: 11px;
  padding: 11px 12px;
  border: 1px solid #e1e9f1;
  border-radius: 9px;
  background: #f8fbfe;
}

.selected-code-detail > strong,
.selected-code-detail > small {
  display: block;
}

.selected-code-detail > strong {
  overflow-wrap: anywhere;
  color: #345a7f;
  font-size: 10px;
}

.selected-code-detail > small {
  margin-top: 8px;
  color: #8191a2;
  font-size: 8px;
}

.code-change-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
}

.code-change-chips span {
  padding: 4px 6px;
  border-radius: 6px;
  color: #6d5b37;
  background: #fff6df;
  font-size: 8px;
}

.code-note-field {
  margin-top: 11px;
}

.code-note-field label,
.result-sample-picker .sample-select-group > label {
  display: block;
  margin-bottom: 6px;
  color: #526b84;
  font-size: 9px;
  font-weight: 800;
}

.code-note-field input {
  width: 100%;
  height: 38px;
  padding: 0 11px;
  border: 1px solid #d6e0ea;
  border-radius: 8px;
  outline: none;
  color: #173e68;
  background: #fbfdff;
  font: inherit;
  font-size: 10px;
}

.code-note-field input:focus {
  border-color: #55a7eb;
  box-shadow: 0 0 0 3px rgba(42, 145, 234, 0.1);
}

.code-note-field small {
  display: block;
  margin-top: 5px;
  color: #8997a7;
  font-size: 8px;
}

.result-sample-picker {
  margin: 18px 0;
  padding: 14px 16px;
  border: 1px solid #d6e4ef;
  border-radius: 12px;
  background: #fff;
}

.result-sample-copy {
  min-width: 230px;
  align-items: flex-start;
  flex-direction: column;
  gap: 3px;
}

.result-sample-copy strong {
  color: #173f68;
  font-size: 12px;
}

.result-sample-copy small {
  color: #8292a4;
  font-size: 9px;
}

.result-sample-picker .sample-select-group {
  max-width: 520px;
}

.version-overview {
  align-items: flex-start;
  margin-top: 15px;
  padding: 14px;
  border: 1px solid #dce7f1;
  border-radius: 11px;
  background: #f8fbfe;
}

.version-overview-main {
  min-width: 0;
}

.version-label-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 7px;
}

.code-version {
  color: #176fc9;
  font-size: 15px;
  font-weight: 850;
}

.version-state,
.original-badge {
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 850;
}

.version-state.current {
  color: #177d59;
  background: #e6f7ef;
}

.version-state.outdated {
  color: #a4531b;
  background: #fff0df;
}

.original-badge {
  color: #6252ac;
  background: #efecff;
}

.version-overview-main > strong {
  color: #2a4968;
  font-size: 11px;
}

.version-overview-main p {
  margin: 5px 0;
  color: #65778b;
  font-size: 10px;
}

.version-overview-main small {
  color: #8997a7;
  font-size: 8px;
}

.run-history {
  margin-top: 14px;
}

.svm-run-history {
  padding: 16px;
  border: 1px solid #dce5ef;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(23, 51, 83, 0.05);
}

.run-history-head strong {
  color: #193f68;
  font-size: 11px;
}

.run-history-head span {
  color: #7c8b9d;
  font-size: 9px;
}

.run-history-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.run-history-item {
  position: relative;
  min-width: 0;
  padding: 10px;
  border: 1px solid #dfe7ef;
  border-radius: 9px;
  text-align: left;
  color: #526a82;
  background: #fff;
  cursor: pointer;
}

.run-history-item:hover,
.run-history-item.active {
  border-color: #55a4e7;
  background: #f1f8ff;
}

.run-history-item.outdated:not(.active) {
  border-color: #eadac6;
  background: #fffcf7;
}

.run-history-title,
.run-history-meta {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.run-history-title strong {
  color: #1d5f9e;
  font-size: 11px;
}

.run-history-title span,
.run-history-meta span,
.run-history-meta em {
  overflow: hidden;
  color: #8291a1;
  font-size: 8px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-history-meta {
  margin-top: 5px;
}

.run-history-meta em {
  max-width: 55%;
}

.run-current-mark {
  display: inline-block;
  margin-top: 7px;
  padding: 3px 5px;
  border-radius: 5px;
  color: #176fc9;
  background: #dcedfc;
  font-size: 7px;
  font-weight: 850;
}

.code-inspector {
  margin-top: 18px;
  padding: 15px;
  border: 1px solid #d8e4ef;
  border-radius: 11px;
  background: #f7fafc;
}

.code-inspector-title strong {
  display: block;
  margin-top: 4px;
  color: #183f68;
  font-size: 12px;
}

.code-loading {
  padding: 18px 0 4px;
  color: #718297;
  font-size: 10px;
}

.code-file-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.code-file-tabs button {
  padding: 6px 8px;
  border: 1px solid #d4dfeb;
  border-radius: 7px;
  color: #60758a;
  background: #fff;
  font-size: 8px;
  cursor: pointer;
}

.code-file-tabs button.active {
  border-color: #4e9ee3;
  color: #176fc9;
  background: #eaf5ff;
}

.code-content,
.code-diff pre {
  max-height: 420px;
  margin: 8px 0 0;
  padding: 13px;
  overflow: auto;
  border-radius: 8px;
  color: #d5e4f2;
  background: #101d2b;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 9px;
  line-height: 1.55;
  white-space: pre;
}

.code-diff {
  margin-top: 14px;
}

.code-diff > strong {
  color: #284e74;
  font-size: 10px;
}

.code-diff p,
.code-diff small {
  color: #748599;
  font-size: 9px;
}

.analysis-setup {
  margin-bottom: 14px;
  padding: 18px;
  border: 1px solid #d6e2ed;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(21, 56, 92, 0.05);
}

.setup-head,
.setup-section-head,
.setup-footer,
.current-sample-summary,
.compact-code-meta {
  display: flex;
  align-items: center;
}

.setup-head,
.setup-section-head,
.setup-footer {
  justify-content: space-between;
}

.setup-head {
  gap: 18px;
  margin-bottom: 13px;
}

.setup-title h2 {
  margin: 4px 0 3px;
  color: #102b4c;
  font-size: 18px;
  letter-spacing: -0.025em;
}

.setup-title p {
  margin: 0;
  color: #718197;
  font-size: 11px;
}

.setup-persistence {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border-radius: 999px;
  color: #27745a;
  background: #edf9f4;
  font-size: 9px;
}

.setup-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 12px;
}

.sample-setup,
.code-setup {
  min-width: 0;
  padding: 13px;
  border: 1px solid #e0e8f0;
  border-radius: 11px;
  background: #f9fbfd;
}

.setup-section-head {
  min-height: 30px;
  gap: 10px;
  margin-bottom: 10px;
}

.setup-section-title strong,
.setup-section-title span {
  display: block;
}

.setup-section-title strong {
  color: #173f68;
  font-size: 12px;
}

.setup-section-title span {
  margin-top: 2px;
  color: #8391a2;
  font-size: 9px;
}

.sample-mode-switch {
  flex: 0 0 auto;
  display: flex;
  padding: 2px;
  border: 1px solid #dce5ee;
  border-radius: 8px;
  background: #eef3f7;
}

.sample-mode-switch button {
  height: 26px;
  padding: 0 9px;
  border: 0;
  border-radius: 6px;
  color: #728398;
  background: transparent;
  font: inherit;
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
}

.sample-mode-switch button.active {
  color: #176eb8;
  background: #fff;
  box-shadow: 0 1px 4px rgba(29, 68, 104, 0.13);
}

.sample-mode-switch button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.saved-sample-list {
  max-height: 142px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 3px;
  overflow-y: auto;
}

.saved-sample-item {
  display: flex;
  align-items: stretch;
  gap: 5px;
  border: 1px solid #dce5ee;
  border-radius: 9px;
  background: #fff;
  transition: border-color 0.18s, background 0.18s;
}

.saved-sample-item:hover {
  border-color: #b8d1e7;
}

.saved-sample-item.active {
  border-color: #74b5ec;
  background: #f0f8ff;
  box-shadow: inset 3px 0 #2f91ed;
}

.sample-choice {
  min-width: 0;
  flex: 1;
  padding: 8px 10px;
  border: 0;
  color: inherit;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.sample-choice strong,
.sample-choice span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-choice strong {
  color: #244a70;
  font-size: 10px;
}

.saved-sample-item.active .sample-choice strong {
  color: #126db8;
}

.sample-choice span {
  margin-top: 2px;
  color: #8190a1;
  font-size: 8px;
}

.sample-choice:disabled {
  cursor: not-allowed;
}

.sample-delete-icon {
  width: 34px;
  margin: 5px 5px 5px 0;
  border: 0;
  border-radius: 7px;
  color: #9d6871;
  background: transparent;
  font: inherit;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
}

.sample-delete-icon:hover:not(:disabled) {
  color: #bd4053;
  background: #ffedf0;
}

.sample-delete-icon:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.sample-empty-compact,
.code-setup-empty {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed #bfd2e3;
  border-radius: 9px;
  color: #71869b;
  background: #fff;
  font-size: 9px;
}

.sample-empty-compact button {
  padding: 5px 8px;
  border: 0;
  border-radius: 6px;
  color: #176eb8;
  background: #eaf5fe;
  font: inherit;
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
}

.sample-create-inline {
  display: flex;
  gap: 7px;
}

.sample-create-inline input,
.code-note-input {
  min-width: 0;
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d6e0ea;
  border-radius: 8px;
  outline: none;
  color: #173e68;
  background: #fff;
  font: inherit;
  font-size: 10px;
}

.sample-create-inline input:focus,
.code-note-input:focus {
  border-color: #55a7eb;
  box-shadow: 0 0 0 3px rgba(42, 145, 234, 0.1);
}

.sample-create-inline .secondary-button {
  flex: 0 0 auto;
  min-width: 60px;
  height: 36px;
}

.compact-code-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.compact-code-field {
  min-width: 0;
}

.compact-code-field > label {
  display: block;
  margin-bottom: 5px;
  color: #526b84;
  font-size: 9px;
  font-weight: 800;
}

.compact-code-field select {
  height: 36px;
  padding-right: 28px;
  font-size: 9px;
}

.compact-code-meta {
  min-height: 25px;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 5px;
}

.compact-code-meta .code-version,
.compact-code-meta .version-state {
  padding: 3px 5px;
  font-size: 7px;
}

.compact-code-meta p {
  min-width: 0;
  flex: 1 1 100%;
  margin: 0;
  overflow: hidden;
  color: #73869a;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.code-note-input {
  height: 32px;
  margin-top: 5px;
  font-size: 9px;
}

.setup-footer {
  gap: 10px;
  margin-top: 10px;
  padding: 9px 11px 0;
  border-top: 1px solid #edf1f5;
}

.current-sample-summary {
  min-width: 0;
  gap: 7px;
}

.current-sample-summary span,
.current-sample-summary em {
  color: #8291a2;
  font-size: 8px;
  font-style: normal;
}

.current-sample-summary strong {
  overflow: hidden;
  color: #194e7e;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-setup + .environment-card {
  min-height: 54px;
  margin-bottom: 18px;
  padding: 9px 14px;
}

.analysis-setup + .environment-card .environment-icon {
  width: 28px;
  height: 28px;
  font-size: 12px;
}

.analysis-setup + .environment-card .environment-copy strong {
  font-size: 11px;
}

.analysis-setup + .environment-card .environment-copy span,
.analysis-setup + .environment-card .environment-copy small {
  font-size: 9px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1080px) {
  .channel-grid,
  .svm-grid,
  .code-selector-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .intro-row {
    align-items: flex-start;
    flex-direction: column;
  }
  .path-gallery {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .count-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .count-arrow {
    display: none;
  }
  .selected-sample {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .setup-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 720px) {
  .hero-inner,
  .hero-menu,
  .workspace {
    width: min(100% - 32px, 1320px);
  }
  .hero-inner {
    min-height: 112px;
  }
  .hero-meta,
  .step-list {
    display: none;
  }
  .channel-grid,
  .svm-grid,
  .code-selector-grid,
  .compact-code-grid,
  .summary-grid,
  .count-metrics {
    grid-template-columns: 1fr;
  }
  .hero-menu {
    overflow-x: auto;
  }
  .menu-button {
    flex: 1;
  }
  .path-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .validation-summary,
  .validation-channel-head,
  .setup-head,
  .setup-section-head,
  .setup-footer,
  .sample-panel-head,
  .sample-controls,
  .selected-sample,
  .code-selection-head,
  .result-sample-picker,
  .version-overview {
    align-items: flex-start;
    flex-direction: column;
  }
  .analysis-setup {
    padding: 14px;
  }
  .setup-head,
  .setup-section-head,
  .setup-footer {
    align-items: stretch;
  }
  .setup-persistence,
  .sample-mode-switch {
    align-self: flex-start;
  }
  .current-sample-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
  .sample-select-group,
  .sample-create-group,
  .sample-version-alert,
  .result-sample-picker .sample-select-group,
  .version-overview .secondary-button {
    width: 100%;
  }
  .action-card {
    align-items: stretch;
    flex-direction: column;
  }
  .svm-action-card .condition-note {
    align-items: flex-start;
  }
  .action-buttons,
  .primary-button {
    width: 100%;
  }
  .brand-copy h1 {
    font-size: 20px;
  }
}
/* Detection threshold controls and run comparison */
.parameter-setup {
  min-width: 0;
  padding: 13px;
  border: 1px solid #dce7f1;
  border-radius: 11px;
  background: linear-gradient(145deg, #f8fbfe 0%, #f3f8fc 100%);
}

.parameter-value-badge {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 8px;
  border: 1px solid #b9dafa;
  border-radius: 8px;
  color: #1b68a8;
  background: #edf7ff;
}

.parameter-value-badge span {
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.1em;
}

.parameter-value-badge strong {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.threshold-control {
  padding: 10px 11px;
  border: 1px solid #dbe6f0;
  border-radius: 9px;
  background: #fff;
}

.threshold-label-row,
.threshold-scale,
.threshold-input-row,
.threshold-number,
.parameter-comparison-head,
.parameter-label-row {
  display: flex;
  align-items: center;
}

.threshold-label-row,
.threshold-scale,
.parameter-comparison-head {
  justify-content: space-between;
}

.threshold-label-row {
  gap: 10px;
  margin-bottom: 8px;
}

.threshold-label-row label {
  color: #284f74;
  font-size: 9px;
  font-weight: 900;
}

.threshold-label-row span,
.threshold-scale span {
  color: #8293a4;
  font-size: 8px;
}

.threshold-range {
  width: 100%;
  height: 4px;
  margin: 4px 0 5px;
  border-radius: 999px;
  outline: none;
  background: linear-gradient(90deg, #34a2f4 0%, #8bc9f3 50%, #dce6ef 100%);
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.threshold-range::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #258fe5;
  box-shadow: 0 1px 5px rgba(22, 89, 145, 0.35);
  cursor: grab;
  appearance: none;
  -webkit-appearance: none;
}

.threshold-range::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #258fe5;
  box-shadow: 0 1px 5px rgba(22, 89, 145, 0.35);
  cursor: grab;
}

.threshold-range:focus-visible {
  box-shadow: 0 0 0 3px rgba(42, 145, 234, 0.16);
}

.threshold-range:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.threshold-scale {
  margin-bottom: 9px;
}

.threshold-input-row {
  gap: 8px;
}

.threshold-number {
  flex: 0 0 105px;
  gap: 6px;
}

.threshold-number span {
  color: #687f94;
  font-size: 8px;
  font-weight: 800;
  white-space: nowrap;
}

.threshold-number input,
.parameter-note-input {
  border: 1px solid #d6e1eb;
  border-radius: 7px;
  outline: none;
  color: #174875;
  background: #fbfdff;
  font: inherit;
  font-variant-numeric: tabular-nums;
}

.threshold-number input {
  min-width: 0;
  width: 58px;
  height: 30px;
  padding: 0 6px;
  font-size: 9px;
  font-weight: 900;
}

.threshold-presets {
  min-width: 0;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px;
}

.threshold-presets button {
  height: 30px;
  padding: 0 3px;
  border: 1px solid #dce6ee;
  border-radius: 7px;
  color: #6c8094;
  background: #f7fafc;
  font: inherit;
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.threshold-presets button:hover:not(:disabled),
.threshold-presets button.active {
  border-color: #69ade6;
  color: #126eb7;
  background: #eaf6ff;
}

.threshold-presets button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.parameter-note-input {
  width: 100%;
  height: 32px;
  margin-top: 8px;
  padding: 0 9px;
  font-size: 9px;
}

.threshold-number input:focus,
.parameter-note-input:focus {
  border-color: #55a7eb;
  box-shadow: 0 0 0 3px rgba(42, 145, 234, 0.1);
}

.parameter-help {
  margin: 7px 0 0;
  color: #72879a;
  font-size: 8px;
  line-height: 1.45;
}

.parameter-setup-empty {
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #bfd2e3;
  border-radius: 9px;
  color: #71869b;
  background: #fff;
  font-size: 9px;
}

.parameter-overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 13px;
  padding: 13px 14px;
  border: 1px solid #cce2f4;
  border-radius: 11px;
  background: linear-gradient(135deg, #f4faff 0%, #edf7ff 100%);
}

.parameter-overview-main {
  min-width: 0;
}

.parameter-label-row {
  gap: 6px;
  margin-bottom: 7px;
}

.parameter-badge,
.selected-run-badge {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 900;
}

.parameter-badge {
  color: #086dae;
  background: #dff1ff;
}

.selected-run-badge {
  color: #29765e;
  background: #e0f5ec;
}

.parameter-overview-main > strong {
  display: block;
  color: #173f67;
  font-size: 12px;
}

.parameter-overview-main p {
  margin: 4px 0;
  color: #5f7790;
  font-size: 9px;
}

.parameter-overview-main small {
  color: #8291a1;
  font-size: 8px;
}

.parameter-comparison {
  margin: 13px 0;
  padding: 13px;
  border: 1px solid #cde5dc;
  border-radius: 11px;
  background: #f5fbf8;
}

.parameter-comparison-head {
  gap: 10px;
  margin-bottom: 9px;
}

.parameter-comparison-head strong {
  color: #245b4b;
  font-size: 11px;
}

.parameter-comparison-head span {
  color: #66897e;
  font-size: 8px;
  font-weight: 800;
}

.parameter-comparison-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr)) minmax(140px, 1.2fr);
  gap: 7px;
}

.comparison-metric,
.comparison-baseline {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #dcece6;
  border-radius: 8px;
  background: #fff;
}

.comparison-metric span,
.comparison-baseline span,
.comparison-baseline em {
  display: block;
  color: #7a928a;
  font-size: 8px;
  font-style: normal;
}

.comparison-metric strong,
.comparison-baseline strong {
  display: inline-block;
  margin-top: 4px;
  color: #244f43;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.comparison-metric em {
  margin-left: 6px;
  color: #7c8e89;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.comparison-metric em.positive {
  color: #0b8d64;
}

.comparison-metric em.negative {
  color: #c15362;
}

.comparison-baseline em {
  margin-top: 2px;
}

.parameter-comparison-empty {
  margin: 12px 0;
  padding: 10px 12px;
  border: 1px dashed #cfdae4;
  border-radius: 9px;
  color: #7b8d9e;
  background: #fafcfe;
  font-size: 8px;
}

.feature-report {
  margin: 16px 0 20px;
  padding: 17px;
  border: 1px solid #d9e5ef;
  border-radius: 12px;
  background: #fafdff;
}

.feature-report-head,
.feature-report-title,
.formula-card-head {
  display: flex;
}

.feature-report-head {
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.feature-report-title {
  min-width: 0;
  flex-direction: column;
}

.feature-report-title h3 {
  margin: 5px 0 3px;
  color: #153e69;
  font-size: 14px;
}

.feature-report-title p {
  margin: 0;
  color: #75889b;
  font-size: 9px;
}

.result-download {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #2e8ddb;
  border-radius: 8px;
  color: #fff;
  background: #237fca;
  font-size: 9px;
  font-weight: 900;
  text-decoration: none;
}

.result-download:hover {
  background: #176fb6;
}

.feature-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  margin-top: 14px;
}

.feature-summary-card {
  min-width: 0;
  padding: 10px 11px;
  border: 1px solid #e1e9f0;
  border-radius: 8px;
  background: #fff;
}

.feature-summary-card span,
.feature-summary-card small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feature-summary-card span {
  color: #60758a;
  font-size: 8px;
  font-weight: 800;
}

.feature-summary-card strong {
  display: block;
  margin: 5px 0 2px;
  color: #15598f;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.feature-summary-card small {
  color: #92a0ad;
  font-size: 7px;
}

.feature-table-wrap {
  max-height: 410px;
  margin-top: 12px;
  overflow: auto;
  border: 1px solid #dfe7ee;
  border-radius: 9px;
  background: #fff;
}

.feature-table {
  width: 100%;
  min-width: 1460px;
  border-collapse: separate;
  border-spacing: 0;
  color: #40566d;
  font-size: 9px;
  font-variant-numeric: tabular-nums;
}

.feature-table th,
.feature-table td {
  padding: 9px 10px;
  border-right: 1px solid #edf1f5;
  border-bottom: 1px solid #edf1f5;
  text-align: right;
  white-space: nowrap;
}

.feature-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  color: #4a657f;
  background: #eef5fb;
  font-size: 8px;
}

.feature-table thead th span,
.feature-table thead th small {
  display: block;
}

.feature-table thead th small {
  margin-top: 2px;
  color: #8b9aaa;
  font-weight: 600;
}

.feature-table th:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 112px;
  text-align: left;
  color: #275a88;
  background: #f8fbfe;
}

.feature-table thead th:first-child {
  z-index: 3;
  background: #e8f2fa;
}

.feature-table tbody tr:last-child th,
.feature-table tbody tr:last-child td {
  border-bottom: 0;
}

.feature-table th:last-child,
.feature-table td:last-child {
  border-right: 0;
}

.feature-empty {
  margin-top: 13px;
  padding: 15px;
  border: 1px dashed #cedae5;
  border-radius: 9px;
  text-align: center;
  background: #fff;
}

.feature-empty strong {
  color: #5f7387;
  font-size: 10px;
}

.feature-empty p {
  margin: 4px 0 0;
  color: #8a98a7;
  font-size: 8px;
}

.formula-guide {
  margin-top: 12px;
  border-top: 1px solid #e5ebf1;
}

.formula-guide summary {
  padding: 12px 1px 2px;
  color: #176eb4;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}

.formula-note {
  margin: 9px 0;
  padding: 9px 10px;
  border-radius: 7px;
  color: #60768b;
  background: #edf5fb;
  font-size: 8px;
  line-height: 1.5;
}

.formula-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.formula-card {
  min-width: 0;
  padding: 11px;
  border: 1px solid #e2e9f0;
  border-radius: 8px;
  background: #fff;
}

.formula-card-head {
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.formula-card-head strong {
  color: #254d72;
  font-size: 9px;
}

.formula-card-head span {
  color: #8b99a7;
  font-size: 7px;
  font-weight: 800;
}

.formula-card code {
  display: block;
  margin-top: 8px;
  overflow-wrap: anywhere;
  color: #1266a6;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  font-size: 8px;
  line-height: 1.55;
}

.formula-card p {
  margin: 6px 0 0;
  color: #718396;
  font-size: 8px;
  line-height: 1.45;
}

@media (max-width: 980px) {
  .feature-summary-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .threshold-input-row,
  .parameter-overview {
    align-items: stretch;
    flex-direction: column;
  }
  .threshold-number {
    flex-basis: auto;
  }
  .parameter-comparison-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .comparison-baseline {
    grid-column: 1/-1;
  }
  .feature-report-head {
    align-items: stretch;
    flex-direction: column;
  }
  .result-download {
    justify-content: center;
  }
  .feature-summary-grid,
  .formula-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`],
})
export class PageMainComponent implements OnInit, OnDestroy {
    public readonly labelOptions = [
        { value: 'control', title: 'control' },
        { value: 'test1', title: 'test1' },
        { value: 'test2', title: 'test2' },
        { value: 'test3', title: 'test3' }
    ];
    public readonly acceptedTypes = '.mp4,.mov,.avi,.mkv,.webm,.m4v';

    public readonly defaultChannelLabels: { [key: string]: string } = {
        A: 'control',
        B: 'test1',
        C: 'test2',
        D: 'test3'
    };

    public channels: ChannelConfig[] = [
        this.channel('A', true),
        this.channel('B', true),
        this.channel('C', false),
        this.channel('D', false)
    ];

    public capability: any = null;
    public capabilityLoading = true;
    public requestError = '';
    public svmJob: any = null;
    public svmRequestError = '';
    public activeMenu = 'analysis';
    public validationChannel = '';
    public samples: any[] = [];
    public selectedSample: any = null;
    public sampleRuns: any[] = [];
    public sampleName = '';
    public sampleError = '';
    public sampleLoading = true;
    public sampleDeletingId = '';
    public showSampleCreator = false;
    public readonly thresholdPresets = [0.1, 0.2, 0.25, 0.3, 0.5];
    public confidenceThreshold = 0.2;
    public thresholdNote = '';
    public codeVersions: any = { channel: [], svm: [] };
    public selectedChannelCodeId = '';
    public selectedSvmCodeId = '';
    public svmCodeNote = '';
    public codeSnapshot: any = null;
    public codeLoading = false;
    public codeError = '';
    public activeCodeFile = '';

    private channelPollTimers: { [key: string]: any } = {};
    private svmPollTimer: any = null;
    private pollFailures: { [key: string]: number } = {};
    private svmPollFailures = 0;
    private destroyed = false;

    constructor(@Inject( ChangeDetectorRef) private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await Promise.all([
            this.refreshCapabilities(),
            this.refreshSamples()
        ]);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        Object.keys(this.channelPollTimers).forEach((channel) => this.stopChannelPolling(channel));
        this.stopSvmPolling();
    }

    public get registeredChannels() {
        return this.channels.filter((item) => item.enabled);
    }

    public get analyzedChannels() {
        return this.channels.filter((item) => item.job);
    }

    public get confidenceThresholdValid() {
        return Number.isFinite(this.confidenceThreshold)
            && this.confidenceThreshold >= 0.01
            && this.confidenceThreshold <= 0.99;
    }

    public get selectedChannelCode() {
        return this.selectedCodeVersion('channel');
    }

    public get selectedSvmCode() {
        return this.selectedCodeVersion('svm');
    }

    public get activeValidationChannel() {
        return this.analyzedChannels.find(
            (item) => item.channel === this.validationChannel
        ) || this.analyzedChannels[0] || null;
    }

    public get svmRuns() {
        return this.sampleRuns.filter((run) => run.job_type === 'svm');
    }

    public get featureParameters() {
        return this.capability?.feature_parameters || [];
    }

    public get readyChannels() {
        return this.channels.filter((item) => {
            const state = this.channelState(item.channel);
            return item.enabled
                && item.job
                && state
                && state.status === 'completed'
                && Number(state.path_count) > 0;
        });
    }

    public get isAnyChannelRunning() {
        return this.channels.some((item) => this.channelIsRunning(item));
    }

    public get svmIsRunning() {
        return this.svmJob && ['queued', 'running'].includes(this.svmJob.state);
    }

    public get isRunning() {
        return this.isAnyChannelRunning || this.svmIsRunning;
    }

    public analysisActivityLabel() {
        const activity = this.capability?.activity;
        if (!activity?.active_count) return '현재 실행 중이거나 대기 중인 분석이 없습니다.';
        const running = (activity.jobs || []).find((job: any) => job.state === 'running');
        if (running) {
            const target = running.job_type === 'svm'
                ? 'SVM'
                : (running.channels || []).map((channel: string) => 'ch.' + channel).join(', ');
            const sample = running.sample_name || '다른 샘플';
            const queued = Number(activity.queued_count || 0);
            return "'" + sample + "'의 " + target + ' 분석 중'
                + (queued ? ' · 대기 ' + queued + '건' : '');
        }
        return '분석 실행 대기 ' + Number(activity.queued_count || activity.active_count) + '건';
    }

    public get canRunSvm() {
        if (
            this.svmIsRunning
            || !this.selectedSvmCodeId
            || this.readyChannels.length < 2
        ) return false;
        const hasControl = this.readyChannels.some((item) => item.label === 'control');
        const hasTest = this.readyChannels.some((item) => item.label !== 'control');
        return hasControl && hasTest;
    }

    public get svmConditionHint() {
        const ready = this.readyChannels;
        if (ready.length < 2) {
            return 'Track path가 추출된 완료 채널이 ' + ready.length
                + '개입니다. 채널별 추출을 먼저 완료해 주세요.';
        }
        const hasControl = ready.some((item) => item.label === 'control');
        const hasTest = ready.some((item) => item.label !== 'control');
        if (!hasControl || !hasTest) {
            return '완료 채널 중 control 1개 이상과 test 라벨 1개 이상이 필요합니다.';
        }
        return ready.map((item) => 'ch.' + item.channel).join(', ')
            + '의 완료된 Path로 SVM을 실행할 수 있습니다.';
    }

    public async refreshCapabilities() {
        this.capabilityLoading = true;
        this.requestError = '';
        this.render();
        try {
            this.capability = await this.callApi('capabilities');
        } catch (error) {
            this.requestError = this.errorMessage(error);
        } finally {
            this.capabilityLoading = false;
            this.render();
        }
    }

    public async refreshSamples(preferredSampleId = '') {
        this.sampleLoading = true;
        this.sampleError = '';
        this.render();
        try {
            this.samples = await this.callApi('samples');
            const remembered = preferredSampleId || this.rememberedSampleId();
            const selected = this.samples.find((sample) => sample.sample_id === remembered)
                || this.samples[0]
                || null;
            if (selected) {
                await this.loadSample(selected.sample_id);
            } else {
                this.resetSampleWorkspace();
            }
        } catch (error) {
            this.sampleError = this.errorMessage(error);
        } finally {
            this.sampleLoading = false;
            this.render();
        }
    }

    public async createSample() {
        const name = this.sampleName.trim();
        if (!name || this.isRunning) return;
        this.sampleLoading = true;
        this.sampleError = '';
        this.render();
        try {
            const sample = await this.callApi('create_sample', { name });
            this.sampleName = '';
            this.showSampleCreator = false;
            await this.refreshSamples(sample.sample_id);
        } catch (error) {
            this.sampleError = this.errorMessage(error);
        } finally {
            this.sampleLoading = false;
            this.render();
        }
    }

    public async deleteSample(sample: any) {
        if (!sample || this.isRunning || this.sampleDeletingId) return;
        const sampleId = sample.sample_id;
        const sampleName = sample.name;
        if (!window.confirm(
            '"' + sampleName + '" 샘플과 저장된 영상·분석 결과를 모두 삭제할까요?\n'
            + '삭제한 데이터는 복구할 수 없습니다.'
        )) return;

        const selectedSampleId = this.selectedSample?.sample_id || '';
        const deletingSelectedSample = selectedSampleId === sampleId;
        this.sampleDeletingId = sampleId;
        this.sampleError = '';
        this.render();
        try {
            await this.callApi('samples', { action: 'delete', sample_id: sampleId });
            if (deletingSelectedSample) this.forgetSample();
            await this.refreshSamples(deletingSelectedSample ? '' : selectedSampleId);
        } catch (error) {
            this.sampleError = this.errorMessage(error);
        } finally {
            this.sampleDeletingId = '';
            this.render();
        }
    }

    public toggleSampleCreator(show: boolean) {
        if (this.isRunning || this.sampleLoading) return;
        this.showSampleCreator = show;
        this.sampleError = '';
        this.render();
    }

    public updateSampleName(event: Event) {
        this.sampleName = (event.target as HTMLInputElement).value;
    }

    public updateConfidenceThreshold(event: Event) {
        const value = Number((event.target as HTMLInputElement).value);
        if (!Number.isFinite(value)) return;
        this.confidenceThreshold = Math.min(0.99, Math.max(0.01, value));
        this.render();
    }

    public setConfidenceThreshold(value: number) {
        if (this.isRunning) return;
        this.confidenceThreshold = Math.min(0.99, Math.max(0.01, value));
        this.render();
    }

    public updateThresholdNote(event: Event) {
        this.thresholdNote = (event.target as HTMLInputElement).value;
    }

    public updateSvmCodeNote(event: Event) {
        this.svmCodeNote = (event.target as HTMLInputElement).value;
    }

    public selectCodeVersion(jobType: string, event: Event) {
        if (this.isRunning) return;
        const versionId = (event.target as HTMLSelectElement).value;
        if (jobType === 'svm') {
            this.selectedSvmCodeId = versionId;
        } else {
            this.selectedChannelCodeId = versionId;
            this.confidenceThreshold = this.codeVersionThreshold(
                this.selectedChannelCode,
                this.confidenceThreshold
            );
        }
        this.render();
    }

    public codeVersionThreshold(version: any, fallback = 0.2) {
        const value = Number(version?.parameters?.confidence_threshold);
        return Number.isFinite(value) ? value : fallback;
    }

    public codeVersionLabel(run: any) {
        return run?.code_version?.label || '코드 기록 없음';
    }

    public codeFileContent() {
        return (this.codeSnapshot?.files || []).find(
            (file: any) => file.name === this.activeCodeFile
        )?.content || '';
    }

    public selectCodeFile(filename: string) {
        this.activeCodeFile = filename;
        this.render();
    }

    public async loadCodeSnapshot(run: any) {
        if (!run?.job_id || this.codeLoading) return;
        this.codeLoading = true;
        this.codeError = '';
        this.codeSnapshot = null;
        this.activeCodeFile = '';
        this.render();
        try {
            this.codeSnapshot = await this.callApi('code_snapshot', {
                job_id: run.job_id
            });
            this.activeCodeFile = this.codeSnapshot?.files?.[0]?.name || '';
        } catch (error) {
            this.codeError = this.errorMessage(error);
        } finally {
            this.codeLoading = false;
            this.render();
        }
    }

    public async selectSample(event: Event) {
        const sampleId = (event.target as HTMLSelectElement).value;
        await this.chooseSample(sampleId);
    }

    public async chooseSample(sampleId: string) {
        if (this.isRunning || this.sampleLoading) return;
        if (!sampleId || sampleId === this.selectedSample?.sample_id) return;
        this.sampleLoading = true;
        this.sampleError = '';
        this.render();
        try {
            await this.loadSample(sampleId);
        } catch (error) {
            this.sampleError = this.errorMessage(error);
        } finally {
            this.sampleLoading = false;
            this.render();
        }
    }

    public async loadSample(sampleId: string) {
        Object.keys(this.channelPollTimers).forEach((channel) => this.stopChannelPolling(channel));
        this.stopSvmPolling();
        const detail = await this.callApi('sample_detail', { sample_id: sampleId });
        this.selectedSample = detail.sample;
        this.sampleRuns = detail.runs || [];
        this.applyDetectionParameters(detail, false);
        this.codeSnapshot = null;
        this.codeError = '';
        this.activeCodeFile = '';
        this.channels = [
            this.channel('A', true),
            this.channel('B', true),
            this.channel('C', false),
            this.channel('D', false)
        ];
        this.channels.forEach((item) => {
            const run = detail.latest_channels?.[item.channel];
            const state = run?.channels?.[item.channel];
            if (!run || !state) return;
            item.enabled = true;
            item.label = state.label || item.label;
            item.filename = state.filename || '';
            item.job = run;
            if (['queued', 'running'].includes(run.state)) {
                this.scheduleChannelPoll(item, 500);
            }
        });
        this.svmJob = detail.latest_svm || null;
        if (this.svmJob && ['queued', 'running'].includes(this.svmJob.state)) {
            this.scheduleSvmPoll(500);
        }
        this.validationChannel = '';
        this.rememberSample(sampleId);
        this.render();
    }

    public channelRuns(channel: string) {
        return this.sampleRuns.filter(
            (run) => run.job_type !== 'svm' && run.channels?.[channel]
        );
    }

    public runThreshold(run: any, fallback?: number) {
        const configured = run?.parameters?.confidence_threshold;
        const channelName = Object.keys(run?.channels || {})[0];
        const channelValue = channelName
            ? run?.channels?.[channelName]?.confidence_threshold
            : undefined;
        const value = Number(
            configured !== undefined
                ? configured
                : channelValue !== undefined
                    ? channelValue
                    : fallback !== undefined
                        ? fallback
                        : 0.2
        );
        return Number.isFinite(value) ? value : 0.2;
    }

    public formatThreshold(value: number) {
        return Number(value).toFixed(2);
    }

    public previousChannelRun(channel: string, run: any) {
        const runs = this.channelRuns(channel);
        const index = runs.findIndex((candidate) => candidate.job_id === run?.job_id);
        return index >= 0 ? runs[index + 1] || null : null;
    }

    public runMetric(run: any, channel: string, metric: string) {
        const channelData = run?.channels?.[channel] || {};
        const stored = channelData[metric];
        const value = Number(
            stored !== undefined
                ? stored
                : ['rotifer_count', 'track_file_count'].includes(metric)
                    ? channelData.path_count || 0
                    : 0
        );
        return Number.isFinite(value) ? value : 0;
    }

    public runMetricDelta(channel: string, run: any, metric: string) {
        const previous = this.previousChannelRun(channel, run);
        if (!previous) return null;
        return this.runMetric(run, channel, metric)
            - this.runMetric(previous, channel, metric);
    }

    public formatMetricDelta(value: number | null) {
        if (value === null || !Number.isFinite(value)) return '-';
        if (value > 0) return '+' + value;
        return String(value);
    }

    public svmThresholdSummary(run: any) {
        const stored = run?.parameters?.source_thresholds || {};
        const channels = Object.keys(run?.channels || {});
        if (!channels.length) return 'threshold 기록 없음';
        return channels.map((channel) => {
            const value = stored[channel] !== undefined
                ? stored[channel]
                : run?.channels?.[channel]?.confidence_threshold;
            return 'ch.' + channel + ' ' + this.formatThreshold(
                value !== undefined ? Number(value) : 0.2
            );
        }).join(' · ');
    }

    public selectChannelRun(item: ChannelConfig, run: any) {
        if (this.isRunning || item.job?.job_id === run.job_id) return;
        const state = run.channels?.[item.channel];
        if (!state) return;
        this.stopChannelPolling(item.channel);
        item.enabled = true;
        item.label = state.label || item.label;
        item.filename = state.filename || '';
        item.file = null;
        item.job = run;
        item.error = '';
        item.requestError = '';
        this.render();
    }

    public selectSvmRun(run: any) {
        if (this.svmIsRunning || !run || this.svmJob?.job_id === run.job_id) return;
        this.stopSvmPolling();
        this.svmJob = run;
        this.svmRequestError = '';
        this.render();
    }

    public formatDate(value: number) {
        if (!Number.isFinite(Number(value))) return '-';
        return new Date(Number(value) * 1000).toLocaleString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    }

    public async toggleChannel(item: ChannelConfig, event: Event) {
        const input = event.target as HTMLInputElement;
        item.enabled = input.checked;
        if (!item.enabled) {
            this.stopChannelPolling(item.channel);
            item.file = null;
            item.filename = '';
            item.error = '';
            item.job = null;
            item.uploadProgress = 0;
            item.uploading = false;
            item.requestError = '';
        }
        this.render();
    }

    public async changeLabel(item: ChannelConfig, event: Event) {
        item.label = (event.target as HTMLSelectElement).value;
        this.render();
    }

    public async selectMenu(menu: string) {
        const nextMenu = ['svm', 'validation'].includes(menu) ? menu : 'analysis';
        this.activeMenu = nextMenu;
        if (nextMenu === 'validation') {
            this.validationChannel = this.activeValidationChannel?.channel || '';
        } else {
            this.validationChannel = '';
        }
        if (nextMenu === 'svm' && !this.svmJob && this.svmRuns.length) {
            this.svmJob = this.svmRuns[0];
        }
        this.render();
    }

    public selectValidationChannel(item: ChannelConfig) {
        if (!item.job || item.channel === this.activeValidationChannel?.channel) return;
        this.validationChannel = item.channel;
        this.render();
    }

    public openTrackPaths(item: ChannelConfig) {
        const artifacts = this.channelState(item.channel)?.path_artifacts || [];
        if (!artifacts.length) return;

        this.validationChannel = item.channel;
        this.activeMenu = 'validation';
        this.render();

        setTimeout(() => {
            if (this.destroyed) return;
            const target = document.getElementById('validation-channel-' + item.channel);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
    }

    public async onFileSelected(item: ChannelConfig, event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files && input.files.length ? input.files[0] : null;
        if (!file) {
            this.render();
            return;
        }
        item.file = null;
        if (!item.job) item.filename = '';
        item.error = '';

        const extension = '.' + (file.name.split('.').pop() || '').toLowerCase();
        const allowed = this.capability?.allowed_extensions || this.acceptedTypes.split(',');
        const maxBytes = (this.capability?.max_file_mb || 1024) * 1024 * 1024;
        if (!allowed.includes(extension)) {
            item.error = '지원하지 않는 형식입니다.';
        } else if (file.size <= 0) {
            item.error = '빈 파일은 업로드할 수 없습니다.';
        } else if (file.size > maxBytes) {
            item.error = '파일은 최대 ' + this.formatBytes(maxBytes) + '까지 가능합니다.';
        } else {
            this.invalidateChannelResult(item);
            item.file = file;
            item.filename = file.name;
        }
        this.render();
    }

    public channelIsRunning(item: ChannelConfig) {
        if (item.uploading) return true;
        return item.job && ['queued', 'running'].includes(item.job.state);
    }

    public canExtract(item: ChannelConfig) {
        return item.enabled
            && this.selectedSample
            && this.selectedChannelCodeId
            && this.confidenceThresholdValid
            && !this.channelIsRunning(item)
            && !this.svmIsRunning
            && this.capability
            && this.capability.ready
            && (item.file || item.job?.channels?.[item.channel]?.has_saved_video)
            && !item.error;
    }

    public async startChannelAnalysis(item: ChannelConfig) {
        if (!this.canExtract(item)) return;
        const sourceJobId = item.file ? '' : item.job?.job_id || '';
        this.stopChannelPolling(item.channel);
        item.job = null;
        item.requestError = '';
        item.uploadProgress = 0;
        item.uploading = true;
        this.activeMenu = 'analysis';
        this.render();

        const registration = {
            channel: item.channel,
            label: item.label,
            source_job_id: sourceJobId,
            confidence_threshold: this.confidenceThreshold
        };
        const form = new FormData();
        form.append('channels', JSON.stringify([registration]));
        form.append('sample_id', this.selectedSample.sample_id);
        form.append('run_note', this.thresholdNote.trim());
        form.append('code_version_id', this.selectedChannelCodeId);
        form.append('confidence_threshold', this.confidenceThreshold.toFixed(4));
        if (item.file) form.append('video_' + item.channel, item.file as File);

        try {
            const response = await this.upload(form, item);
            item.job = response.status;
            item.uploading = false;
            item.uploadProgress = 100;
            this.render();
            this.scheduleChannelPoll(item, 250);
        } catch (error) {
            item.uploading = false;
            item.requestError = this.errorMessage(error);
            this.render();
        }
    }

    public async startSvm() {
        if (!this.canRunSvm) return;
        this.stopSvmPolling();
        this.svmRequestError = '';
        this.svmPollFailures = 0;
        this.activeMenu = 'analysis';
        this.render();

        const sources = this.readyChannels.map((item) => ({
            channel: item.channel,
            label: item.label,
            job_id: item.job.job_id
        }));

        try {
            const response = await this.callApi('start_analysis', {
                mode: 'svm',
                sample_id: this.selectedSample.sample_id,
                run_note: this.svmCodeNote.trim(),
                code_version_id: this.selectedSvmCodeId,
                sources: JSON.stringify(sources)
            });
            this.svmJob = response.status;
            this.render();
            this.scheduleSvmPoll(250);
        } catch (error) {
            this.svmRequestError = this.errorMessage(error);
            this.render();
        }
    }

    public formatBytes(bytes: number) {
        if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
        const value = bytes / Math.pow(1024, index);
        return (index === 0 ? value.toFixed(0) : value.toFixed(1)) + ' ' + units[index];
    }

    public formatAccuracy(value: number) {
        return Number.isFinite(value) ? (value * 100).toFixed(2) + '%' : '-';
    }

    public labelTitle(label: string) {
        const item = this.labelOptions.find((option) => option.value === label);
        return item ? item.title : label;
    }

    public channelState(channel: string) {
        const item = this.channels.find((candidate) => candidate.channel === channel);
        return item?.job?.channels?.[channel] || null;
    }

    public artifactUrl(filename: string) {
        if (!this.svmJob?.job_id || !filename) return '';
        return wiz.url('artifact')
            + '?job_id=' + encodeURIComponent(this.svmJob.job_id)
            + '&filename=' + encodeURIComponent(filename);
    }

    public pathArtifactUrl(channel: string, filename: string) {
        const item = this.channels.find((candidate) => candidate.channel === channel);
        if (!item?.job?.job_id || !filename) return '';
        return wiz.url('artifact')
            + '?job_id=' + encodeURIComponent(item.job.job_id)
            + '&channel=' + encodeURIComponent(channel)
            + '&filename=' + encodeURIComponent(filename);
    }

    public parameterRows(channel: string) {
        return this.channelState(channel)?.parameter_rows || [];
    }

    public parameterSummary(channel: string) {
        return this.channelState(channel)?.parameter_summary || {};
    }

    public parameterCsvUrl(channel: string) {
        const item = this.channels.find((candidate) => candidate.channel === channel);
        const filename = this.channelState(channel)?.parameter_csv;
        if (!item?.job?.job_id || !filename) return '';
        return wiz.url('artifact')
            + '?job_id=' + encodeURIComponent(item.job.job_id)
            + '&channel=' + encodeURIComponent(channel)
            + '&filename=' + encodeURIComponent(filename)
            + '&download=1';
    }

    public formatParameter(value: any) {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return '-';
        return numeric.toLocaleString('ko-KR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4
        });
    }

    public stateLabel(state: string) {
        const labels: any = {
            queued: '대기',
            running: '분석 중',
            completed: '완료',
            completed_with_warnings: '검수 필요',
            failed: '실패',
            error: '오류',
            skipped: '조건 미충족',
            pending: '대기',
            not_applicable: '별도 실행'
        };
        return labels[state] || state || '-';
    }

    private channel(channel: string, enabled: boolean, label = ''): ChannelConfig {
        return {
            channel,
            enabled,
            label: label || this.defaultChannelLabels?.[channel] || 'control',
            file: null,
            filename: '',
            error: '',
            job: null,
            uploadProgress: 0,
            uploading: false,
            requestError: ''
        };
    }

    private invalidateChannelResult(item: ChannelConfig) {
        if (this.channelIsRunning(item)) return;
        this.stopChannelPolling(item.channel);
        if (this.validationChannel === item.channel) this.validationChannel = '';
        item.job = null;
        item.uploadProgress = 0;
        item.requestError = '';
    }

    private async pollChannel(item: ChannelConfig) {
        if (this.destroyed || !item.job?.job_id) return;
        try {
            item.job = await this.callApi('analysis_status', { job_id: item.job.job_id });
            this.pollFailures[item.channel] = 0;
            this.render();
            if (['queued', 'running'].includes(item.job.state)) {
                this.scheduleChannelPoll(item, 1000);
            } else if (this.selectedSample?.sample_id) {
                await this.refreshSampleAfterRun(item.job.job_id);
            }
        } catch (error) {
            this.pollFailures[item.channel] = (this.pollFailures[item.channel] || 0) + 1;
            if (this.pollFailures[item.channel] >= 5) {
                item.requestError = '상태를 연속으로 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.';
                this.render();
                return;
            }
            this.scheduleChannelPoll(item, 1500);
        }
    }

    private scheduleChannelPoll(item: ChannelConfig, delay: number) {
        this.stopChannelPolling(item.channel);
        this.channelPollTimers[item.channel] = setTimeout(() => this.pollChannel(item), delay);
    }

    private stopChannelPolling(channel: string) {
        if (this.channelPollTimers[channel]) {
            clearTimeout(this.channelPollTimers[channel]);
            delete this.channelPollTimers[channel];
        }
    }

    private async pollSvm() {
        if (this.destroyed || !this.svmJob?.job_id) return;
        try {
            this.svmJob = await this.callApi('analysis_status', { job_id: this.svmJob.job_id });
            this.svmPollFailures = 0;
            this.render();
            if (['queued', 'running'].includes(this.svmJob.state)) {
                this.scheduleSvmPoll(1000);
            } else if (this.selectedSample?.sample_id) {
                await this.refreshSampleAfterRun(this.svmJob.job_id);
                this.activeMenu = 'svm';
                this.render();
            }
        } catch (error) {
            this.svmPollFailures += 1;
            if (this.svmPollFailures >= 5) {
                this.svmRequestError = 'SVM 상태를 연속으로 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.';
                this.render();
                return;
            }
            this.scheduleSvmPoll(1500);
        }
    }

    private scheduleSvmPoll(delay: number) {
        this.stopSvmPolling();
        this.svmPollTimer = setTimeout(() => this.pollSvm(), delay);
    }

    private stopSvmPolling() {
        if (this.svmPollTimer) {
            clearTimeout(this.svmPollTimer);
            this.svmPollTimer = null;
        }
    }

    private async refreshSampleAfterRun(activeJobId: string) {
        const sampleId = this.selectedSample?.sample_id;
        if (!sampleId) return;
        try {
            const detail = await this.callApi('sample_detail', { sample_id: sampleId });
            this.selectedSample = detail.sample;
            this.sampleRuns = detail.runs || [];
            this.applyDetectionParameters(detail, true);
            const active = this.sampleRuns.find((run) => run.job_id === activeJobId);
            if (active?.job_type === 'svm') {
                this.svmJob = active;
            } else if (active) {
                const channel = Object.keys(active.channels || {})[0];
                const item = this.channels.find((candidate) => candidate.channel === channel);
                if (item) item.job = active;
            }
            this.samples = await this.callApi('samples');
            this.render();
        } catch (error) {
            this.sampleError = this.errorMessage(error);
            this.render();
        }
    }

    private resetSampleWorkspace() {
        this.selectedSample = null;
        this.sampleRuns = [];
        this.svmJob = null;
        this.codeVersions = { channel: [], svm: [] };
        this.selectedChannelCodeId = '';
        this.selectedSvmCodeId = '';
        this.svmCodeNote = '';
        this.codeSnapshot = null;
        this.codeError = '';
        this.activeCodeFile = '';
        const defaults = this.capability?.detection_parameters || {};
        this.confidenceThreshold = Number(defaults.confidence_threshold || 0.2);
        this.thresholdNote = '';
        this.channels = [
            this.channel('A', true),
            this.channel('B', true),
            this.channel('C', false),
            this.channel('D', false)
        ];
    }

    private rememberedSampleId() {
        try {
            return localStorage.getItem('cellytics.rotifer.sample') || '';
        } catch (error) {
            return '';
        }
    }

    private rememberSample(sampleId: string) {
        try {
            localStorage.setItem('cellytics.rotifer.sample', sampleId);
        } catch (error) { }
    }

    private forgetSample() {
        try {
            localStorage.removeItem('cellytics.rotifer.sample');
        } catch (error) { }
    }

    private applyDetectionParameters(detail: any, preserveSelection: boolean) {
        this.codeVersions = detail.code_versions || { channel: [], svm: [] };
        const channelVersions = this.codeVersions.channel || [];
        const svmVersions = this.codeVersions.svm || [];
        const preservedChannel = preserveSelection
            ? channelVersions.find(
                (version: any) => version.id === this.selectedChannelCodeId
            )
            : null;
        const preservedSvm = preserveSelection
            ? svmVersions.find(
                (version: any) => version.id === this.selectedSvmCodeId
            )
            : null;
        const channelVersion = preservedChannel
            || channelVersions.find((version: any) => version.is_current)
            || channelVersions[0]
            || null;
        const svmVersion = preservedSvm
            || svmVersions.find((version: any) => version.is_current)
            || svmVersions[0]
            || null;
        this.selectedChannelCodeId = channelVersion?.id || '';
        this.selectedSvmCodeId = svmVersion?.id || '';
        const defaults = detail.parameter_defaults
            || this.capability?.detection_parameters
            || {};
        this.confidenceThreshold = this.codeVersionThreshold(
            channelVersion,
            Number(defaults.confidence_threshold || 0.2)
        );
        if (!preserveSelection) {
            this.thresholdNote = '';
            this.svmCodeNote = '';
        }
    }

    private selectedCodeVersion(jobType: string) {
        const versionId = jobType === 'svm'
            ? this.selectedSvmCodeId
            : this.selectedChannelCodeId;
        return (this.codeVersions?.[jobType] || []).find(
            (version: any) => version.id === versionId
        ) || null;
    }

    private async callApi(name: string, data: any = {}) {
        let response: any = await wiz.call(name, data);
        if (response?.responseJSON) response = response.responseJSON;
        const code = Number(response?.code || 0);
        if (code >= 400 || (!code && response?.status >= 400)) {
            throw new Error(this.apiMessage(response) || '요청에 실패했습니다.');
        }
        const payload = response?.data !== undefined ? response.data : response;
        return payload?.data !== undefined ? payload.data : payload;
    }

    private upload(form: FormData, item: ChannelConfig): Promise<any> {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', wiz.url('start_analysis'));
            request.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    item.uploadProgress = Math.round((event.loaded / event.total) * 100);
                    this.render();
                }
            };
            request.onload = () => {
                let payload: any = null;
                try {
                    payload = JSON.parse(request.responseText || '{}');
                } catch (error) {
                    reject(new Error('서버 응답을 해석하지 못했습니다.'));
                    return;
                }
                if (request.status < 200 || request.status >= 300 || Number(payload?.code) >= 400) {
                    reject(new Error(this.apiMessage(payload) || '업로드 요청에 실패했습니다.'));
                    return;
                }
                const responseData = payload?.data !== undefined ? payload.data : payload;
                resolve(responseData?.data !== undefined ? responseData.data : responseData);
            };
            request.onerror = () => reject(new Error('네트워크 연결을 확인해 주세요.'));
            request.onabort = () => reject(new Error('업로드가 취소되었습니다.'));
            request.send(form);
        });
    }

    private errorMessage(error: any) {
        return error?.message || String(error || '알 수 없는 오류가 발생했습니다.');
    }

    private apiMessage(payload: any) {
        return payload?.message
            || payload?.data?.message
            || payload?.data?.data?.message
            || payload?.responseJSON?.message
            || payload?.responseJSON?.data?.message
            || '';
    }

    private render() {
        if (!this.destroyed) this.cdr.detectChanges();
    }
}

export default PageMainComponent;